// extracted by mini-css-extract-plugin
export default {"body":"NoDocCard_body__eD0d+","action":"NoDocCard_action__JmXs-"};